import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-attribute-management',
  imports: [RouterModule],
  templateUrl: './attribute-management.html',
  styleUrl: './attribute-management.scss',
})
export class AttributeManagement {}
